import React from 'react';
import ReactDOM from 'react-dom';

import BoxBody from 'components/BoxBody.jsx';
import Dialog from 'components/Dialog.jsx';
import getMatcher from 'utils/getMatcher';
import Glyph from 'components/Glyph.jsx';
import Input from 'components/Input.jsx';
import OrganizationProfileTeachers from 'collections/OrganizationProfileTeachers';
import ReportToRemindSelectModal from 'support/components/ReportToRemindSelectModal.jsx';
import ScrollableArea from 'components/ScrollableArea.jsx';
import Text from 'components/Text.jsx';
import UserActions from 'user/UserActions';
import { mountModal } from 'lib/modal';

import './styles/SchoolReportModal.scss';

class SchoolReportModal extends React.Component {
  static propTypes = {
    schoolName: React.PropTypes.string.isRequired,
    teachers: React.PropTypes.instanceOf(OrganizationProfileTeachers).isRequired,
    onRequestHide: React.PropTypes.func,
  };

  state = {
    results: this.props.teachers,
  };

  filterTeachers = (query = '') => {
    const isMatch = getMatcher(query);
    return this.props.teachers.filter(teacher => {
      return isMatch([teacher.signature]);
    });
  };

  handleClickTeacher = (teacher) => {
    const modal = (
      <ReportToRemindSelectModal
        options={['This person doesn’t teach at this school']}
        reportee={teacher.getSignature()}
        notesPlaceholder="Why are you reporting this Teacher?"
        onReport={this.reportTeacher.bind(this, teacher)}
      />
    );
    mountModal(modal, this);
  };

  performSearch = () => {
    const input = ReactDOM.findDOMNode(this.refs.teacherSearch);
    const value = input.value;

    this.setState({
      results: this.filterTeachers(value),
      query: value,
    });
  };

  reportTeacher = (teacher, reason, notes) => {
    UserActions.reportUser(teacher.id, reason, notes);
    this.props.onRequestHide();
  };

  renderTeacher = (teacher) => {
    return (
      <div
        key={teacher.id}
        className="SchoolReportModal-result"
        onClick={() => this.handleClickTeacher(teacher)}>
        <div className="SchoolReportModal-result-body">
          <Text className="SchoolReportModal-result-title" truncate>
            {teacher.getSignature()}
          </Text>
        </div>
      </div>
    );
  };

  renderTeachers = () => {
    return this.state.results.map(this.renderTeacher);
  };

  render() {
    return (<Dialog
      eventScreenName="SchoolReportModal"
      {...this.props}
      size="small"
      className="SchoolReportModal SchoolReportModal-noPadding"
      title="Who are you reporting to Remind?"
      hidePreviousButton>
      <BoxBody divided>
        <div className="SchoolReportModal-inputWrapper">
          <Input
            className="SchoolReportModal-input"
            ref="teacherSearch"
            type="text"
            size="large"
            placeholder={`Search for a teacher at ${this.props.schoolName}`}
            autofocus
            value={this.state.query}
            onChange={this.performSearch}
          />
          <Glyph className="SchoolReportModal-inputGlyph" name="search" size="medium" />
        </div>
        <ScrollableArea
          className="SchoolReportModal-list"
          ref="scrollAreaTeachers"
          useBodyChildrenHeight>
          {this.renderTeachers()}
        </ScrollableArea>
      </BoxBody>
    </Dialog>);
  }
}

export default SchoolReportModal;



// WEBPACK FOOTER //
// ./src/schools/components/SchoolReportModal.jsx